export default __webpack_public_path__ + "static/media/apartment.abbf32a1.png";